import { message } from 'antd'
import Email from '../../../../api/Email'
import Members from '../../../../api/Members'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import QuotesApi from '../../../../api/Sales/Quotes'
import Templates from '../../../../api/Templates'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import useModalData from '../../../../elements/Hooks/useModalData'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get, isEmpty, pick, round, set, sum } from 'lodash'
import { numVal } from '../../../../modules/Utils'
import qs from 'query-string'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import DocumentsApi from '../../../../api/Documents'
import { dateFormat, dateVal, moneyInline, normalizeDateTimeToDate, strVal } from '../../../../modules/Utils'
import AddQuote from './AddQuote'

export const AddQuoteContext = React.createContext({})
const templateApi = new Templates()
const emailApi = new Email()
const docsApi = new DocumentsApi()
const api = new QuotesApi()
const formRef = React.createRef()
const serviceSelectRef = React.createRef()

function AddQuoteCont(props) {
  const key = get(props.match, 'params.key')
  const values = qs.parse(props.location.search)
  const enquiryID = values.enquiryID
  const quoteID = values.quoteID
  const type = key ? 'edit' : 'new'

  const { fetch, fetching, object: quote, setObject: setQuote } = useFetchObject(
    () => api.read(key),
    false,
    [key],
    isEmpty(key)
  )
  const { fetch: fetchLines, fetching: fetchingLines, list: lines, setList: setLines } = useFetchList(
    () => api.lines.list(key),
    [quote._rev],
    isEmpty(key)
  )
  const { fetch: fetchAction, fetching: fetchingActions, list: actions } = useFetchList(
    () => docsApi.actions('quotes', quote.status),
    [quote.status],
    isEmpty(quote.status)
  )
  const [submitting, submitFunc] = useSubmit(api.create)
  const [updating, updateFunc] = useSubmit(api.update)
  const [enquiry, setEnquiry] = useState({})
  const [fetchingEnquiry, setFetchingEnquiry] = useState(false)
  const {
    visible: visibleLine,
    modalType,
    object: line,
    submitting: submittingLine,
    setSubmitting,
    removing: removingLine,
    remove: removeLine,
    formRef: lineFormRef,
    checkForm: checkLineForm,
    onShow: onShowLine,
    onCancel: onCancelLine,
    isNew,
  } = useModalData(api.lines.add, api.lines.update, api.lines.remove, fetchLines)

  async function submitLine() {
    const newObject = await checkLineForm()
    console.log({ newObject })
    setSubmitting(true)
    try {
      set(newObject, 'booking.destinations', get(line, 'booking.destinations'))
      normalizeDateTimeToDate(newObject, 'booking.pickup.date')
      normalizeDateTimeToDate(newObject, 'booking.dropoff.date')
      await api.lines.add({ ...newObject, quote: { _id: quote._id } })
      onCancelLine()
      fetchLines()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function updateLine() {
    const newObject = await checkLineForm()
    setSubmitting(true)
    try {
      set(newObject, 'booking.destinations', get(line, 'booking.destinations'))
      normalizeDateTimeToDate(newObject, 'booking.pickup.date')
      normalizeDateTimeToDate(newObject, 'booking.dropoff.date')
      await api.lines.update({
        ...newObject,
        ...pick(line, ['_rev', '_key', '_id']),
      })
      onCancelLine()
      fetchLines()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          normalizeDateTimeToDate(values, 'validity.date')
          normalizeDateTimeToDate(values, 'cpo.date')
          res(values)
        }
      })
    })
  }

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc({
      ...values,
      enquiry: pick(enquiry, ['_id', 'code', '_rev']),
    })
    if (submitted)
      props.history.push({
        pathname: `/clients/quotes/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const quoteDB = await updateFunc({
      ...pick(quote, ['date', 'cpo', 'reference', 'taxType', '_key', '_id', '_rev']),
      ...values,
    })
    if (quoteDB) setQuote(quoteDB)
  }

  const [submittingOperation, submitOperation] = useSubmit(api.operation)
  const [removing, removeFunc] = useSubmit(api.remove)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      case 'remove':
        const removed = await removeFunc({
          ...pick(quote, ['_key', '_rev', '_id']),
        })
        if (removed)
          props.history.replace({
            pathname: `/clients/quotes/`,
          })
        break
      default:
        let newData
        if (operation === 'confirm') {
          const values = await checkForm()
          newData = { ...values, ...pick(quote, ['_key', '_rev', '_id']) }
        } else {
          newData = pick(quote, ['_key', '_rev', '_id'])
        }
        const quoteDB = await submitOperation(operation, newData)
        if (operation === 'duplicate' && quoteDB)
          props.history.push({
            pathname: `/clients/quotes/${quoteDB._key}/update`,
          })
        if (quoteDB) setQuote(quoteDB)
        break
    }
    hide()
  }

  const [emailOptions, setEmailOptions] = useState({})

  async function syncClient() {
    try {
      const { quote } = this.state
      this.setState({
        fetching: true,
      })
      await this.api.syncClient(pick(quote, ['_id', '_rev', '_key']))
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }

  async function showEmail() {
    const emailQuote = { ...quote }
    if (emailQuote.status !== 'Confirmed') {
      message.error(`Can't email non confirmed quotes`)
      return
    }
    const hide = message.loading('Fetching Email Template...', 0)
    try {
      const emailLines = [emailQuote].map((i) => ({
        date: dateFormat(dateVal(i, 'date')),
        no: i.revision ? strVal(i, 'code') + '.0' + strVal(i, 'revision') : strVal(i, 'code'),
        type: strVal(i, 'type'),
        title: strVal(i, 'title'),
        amount: moneyInline(round(sum(lines.map((d) => numVal(d, 'amount.gross'))), 2), strVal(i, 'currency')),
        dueDate: dateFormat(dateVal(i, 'validity.date')),
      }))
      const quoteTemplate = await templateApi.read(strVal(emailQuote, 'company._id').replace('members/', ''), 'quote')
      const emailDetails = get(quoteTemplate, 'email') || {}
      const data = await emailApi.quoteTemplate({
        receiver: get(emailQuote, 'enquirerRep.fn'),
        companyRep: get(emailQuote, 'companyRep.fn'),
        lines: emailLines,
        ...emailDetails,
      })
      const filesList = await api.files([emailQuote].map((s) => s._id))
      const filesMapped = filesList.map((f) => f.uuid)
      setEmailOptions({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        emailFiles: filesList,
        emailLines: [emailQuote],
        emailDetails: {
          to: get(emailQuote, 'enquirerRep.email.label'),
          cc: get(emailQuote, 'companyRep.email.label'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: `[${get(quote, 'enquiry.code')}] ${get(emailDetails, 'subject')} ${get(quote, 'title')} (Your Ref: ${
            get(quote, 'reference.no') || 'None'
          })`,
          attachments: filesMapped,
        },
      })
      hide()
    } catch (e) {
      hide()
      message.error(e.errorMessage)
      setEmailOptions({
        fetchingEmailTemplate: false,
      })
    }
  }

  function onCancelEmail() {
    setEmailOptions({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }

  useTitle(type === 'new' ? `New Quote` : `${quote.code} Quote`)

  async function onChangeEnquiry(enquiryID) {
    if (!enquiryID) {
      setEnquiry({})
    } else {
      try {
        setFetchingEnquiry(true)
        const enquiry = await EnquiriesApi.read(strVal({ enquiryID }, 'enquiryID').replace('activities/', ''))
        setEnquiry(enquiry)
        console.log(enquiry)
        // setQuote({...enquiry, quoteType: enquiry.enquiryType})
        const updatedQuote = pick(enquiry, [
          'assignedTo',
          'centers',
          'company',
          'contract',
          'delivery',
          'due',
          'enquirer',
          'enquirer_rep',
          'isExistingClient',
          'location',
          'sales_Rep',
          'reference',
        ])
        updatedQuote.enquirerRep = enquiry.enquirer_rep
        updatedQuote.companyRep = enquiry.sales_rep
        updatedQuote.title = `${enquiry.title}`
        if (get(enquiry, 'contract.pay')) {
          updatedQuote.currency = get(enquiry, 'contract.pay.currency')
        }
        setQuote({ ...quote, ...updatedQuote, quoteType: enquiry.enquiryType })
      } catch (e) {
        message.error(e.errorMessage)
        console.error(e)
      }
      setFetchingEnquiry(false)
    }
  }

  const [copying, copyEnquiryLinesFunc] = useSubmit(api.copyEnquiryLines)

  async function copyEnquiryLines() {
    await copyEnquiryLinesFunc({ ...pick(quote, ['_key', '_id', '_rev']) })
    fetchLines()
  }

  const isUpdatable = actions.find((a) => a.key === 'update') || type === 'new'

  const { list: enquirerList, fetching: fetchingEnquirer, fetch: fetchEnquirer } = useFetchList(
    EnquiriesApi.enquirerList
  )
  const { visible: visiblePhonebook, onShow: onShowPhoneBook, onCancel: onCancelPhoneBook } = useModalShow(
    undefined,
    fetchEnquirer
  )
  const [ContactPersonLoading, setContactPersonLoading] = useState(false)
  const [isMemberOrganization, setIsMemberOrganization] = useState(true)
  const [contactPerson, setContactPerson] = useState([])

  const onChangeMember = async (id) => {
    setContactPersonLoading(true)
    const key = id.replace('members/', '')
    const membersApi = new Members()
    const memberResponse = await membersApi.get(key)
    let memberData = await memberResponse.json()
    setIsMemberOrganization(memberData.kind !== 'individual')
    const response = await membersApi.representatives.list(key)
    let data = await response.json()
    setContactPerson(data)
    setContactPersonLoading(false)
    return id
  }
  useEffect(() => {
    !isEmpty(quoteID) && onChangeEnquiry(quoteID)
    if (!isEmpty(quote.enquirer)) onChangeMember(quote.enquirer._id)
  }, [get(quote, 'enquirer._id')])

  useEffect(() => {
    !isEmpty(enquiryID) && onChangeEnquiry(enquiryID)
    if (!isEmpty(quote.enquirer)) onChangeMember(quote.enquirer._id)
  }, [get(quote, 'enquirer._id')])
  return (
    <AddQuoteContext.Provider
      value={{
        ...emailOptions,
        fetching,
        fetchingActions,
        copyEnquiryLines,
        enquiry,
        quote,
        fetchLines,
        fetchingLines,
        actions,
        visibleLine,
        isUpdatable,
        submitLine,
        updating,
        submitting,
        modalType,
        line,
        type,
        submittingLine,
        removingLine,
        removeLine,
        updateLine,
        submit,
        lines,
        update,
        fetch,
        onShowLine,
        onCancelLine,
        formRef,
        lineFormRef,
        serviceSelectRef,
        handleActions,
        onChangeEnquiry,
        fetchingEnquiry,
        isNew,
        //email
        showEmail,
        onCancelEmail,
        // non client
        enquirerList,
        fetchingEnquirer,
        fetchEnquirer,
        visiblePhonebook,
        onShowPhoneBook,
        onCancelPhoneBook,
        ContactPersonLoading,
        onChangeMember,
        contactPerson,
        isMemberOrganization,
        syncClient,
      }}>
      <AddQuote />
    </AddQuoteContext.Provider>
  )
}

AddQuoteCont.propTypes = {}
AddQuoteCont.defaultProps = {}

export default compose(withRouter)(AddQuoteCont)
